export const kindsTabs = () => {
    const root = document.querySelector('[data-kinds-tabs]');
    if (!root) return;

    const tabs = Array.from(root.querySelectorAll('[data-kinds-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-kinds-panel]'));

    if (!tabs.length || !panels.length) return;

    const normalizeValue = (value) => value
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '');

    const getResultLabel = (count) => {
        if (count === 1) return 'wynik';
        const mod10 = count % 10;
        const mod100 = count % 100;
        if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) {
            return 'wyniki';
        }
        return 'wyników';
    };

    // Obliczanie wyników znajdujących się poniżej widocznego ekranu (viewport)
    const updateBelowViewportCount = (panel) => {
        const badge = panel.querySelector('[data-kinds-badge]');
        if (!badge) return;

        const activeItems = Array.from(
            panel.querySelectorAll('.kinds__list-item--active, .kinds__table-row--active')
        );

        const viewportBottom = window.innerHeight;
        
        // Filtrujemy elementy, których górna krawędź znajduje się poniżej viewportu
        const belowItems = activeItems.filter((item) => {
            const rect = item.getBoundingClientRect();
            return rect.top >= viewportBottom - 20; // 20px bufora
        });

        const count = belowItems.length;

        if (count > 0) {
            const countEl = badge.querySelector('[data-kinds-badge-count]');
            const wordEl = badge.querySelector('[data-kinds-badge-word]');

            if (countEl) countEl.textContent = String(count);
            if (wordEl) wordEl.textContent = getResultLabel(count);

            badge.hidden = false;
            // Zapisujemy pierwszy ukryty element w dataset dla płynnego scrolla
            badge.firstBelowItem = belowItems[0];
        } else {
            badge.hidden = true;
            badge.firstBelowItem = null;
        }
    };

    const updatePanelResults = (panel, query) => {
        const searchItems = Array.from(panel.querySelectorAll('.kinds__list-item, .kinds__table-row:not(.kinds__table-row--head)'));
        const resultNumber = panel.querySelector('.kinds__results-number');
        const resultWord = panel.querySelector('.kinds__results-word');
        const normalizedQuery = normalizeValue(query.trim());
        let matchCount = 0;

        searchItems.forEach((item) => {
            const itemText = normalizeValue(item.textContent || '');
            const isMatch = normalizedQuery !== '' && itemText.includes(normalizedQuery);

            if (item.classList.contains('kinds__list-item')) {
                item.classList.toggle('kinds__list-item--active', isMatch);
            }

            if (item.classList.contains('kinds__table-row')) {
                item.classList.toggle('kinds__table-row--active', isMatch);
            }

            if (isMatch) matchCount += 1;
        });

        if (resultNumber) resultNumber.textContent = String(matchCount);
        if (resultWord) resultWord.textContent = getResultLabel(matchCount);

        // Po wyszukiwaniu przeliczamy pozycje w viewporcie
        setTimeout(() => updateBelowViewportCount(panel), 50);
    };

    const setActiveTab = (tabName) => {
        tabs.forEach((tab) => {
            const isActive = tab.dataset.kindsTab === tabName;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-selected', String(isActive));
        });

        panels.forEach((panel) => {
            const isActive = panel.dataset.kindsPanel === tabName;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;
            if (isActive) updateBelowViewportCount(panel);
        });
    };

    const bindPanelSearch = (panel) => {
        const searchInput = panel.querySelector('.kinds__panel-search');
        const searchButton = panel.querySelector('.kinds__panel-search-submit');
        const badge = panel.querySelector('[data-kinds-badge]');

        if (searchInput && searchButton) {
            const handleSearch = () => updatePanelResults(panel, searchInput.value);
            searchButton.addEventListener('click', handleSearch);
            searchInput.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    handleSearch();
                }
            });
        }

        // Płynny scroll do pierwszego niewidocznego wyniku
        if (badge) {
            badge.addEventListener('click', () => {
                if (badge.firstBelowItem) {
                    badge.firstBelowItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        }

        updatePanelResults(panel, '');
    };

    // Listener do ponownego przeliczania podczas scrollowania lub zmiany rozmiaru okna
    let scrollTimeout;
    const handleViewportChange = () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
            const activePanel = panels.find((panel) => panel.classList.contains('is-active'));
            if (activePanel) updateBelowViewportCount(activePanel);
        }, 30);
    };

    window.addEventListener('scroll', handleViewportChange, { passive: true });
    window.addEventListener('resize', handleViewportChange);

    tabs.forEach((tab) => {
        tab.addEventListener('click', () => setActiveTab(tab.dataset.kindsTab));
    });

    panels.forEach((panel) => bindPanelSearch(panel));

    const initialActiveTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
    setActiveTab(initialActiveTab.dataset.kindsTab);
};